export enum UnitCardStatus {
    Draft = 0,
    Inactive = 1,
    Active = 2,
    Stolen = 4,
    Lost = 8,
    Frozen = 16,
    ClosedByCustomer = 32,
    SuspectedFraud = 64
}

export namespace UnitCardStatus {
    export function toString(areaUnit: UnitCardStatus): string {
        switch (areaUnit) {
            case UnitCardStatus.Draft:
                return 'Draft';
            case UnitCardStatus.Inactive:
                return 'Inactive';
            case UnitCardStatus.Active:
                return 'Active';
            case UnitCardStatus.Stolen:
                return 'Stolen';
            case UnitCardStatus.Lost:
                return 'Lost';
            case UnitCardStatus.Frozen:
                return 'Frozen';
            case UnitCardStatus.ClosedByCustomer:
                return 'Canceled';
            case UnitCardStatus.SuspectedFraud:
                return 'Suspected Fraud';
            default:
                return null;
        }
    }

    export function listAll() {
        return [UnitCardStatus.Draft, UnitCardStatus.Inactive, UnitCardStatus.Active, UnitCardStatus.Stolen, UnitCardStatus.Lost,
        UnitCardStatus.Frozen, UnitCardStatus.ClosedByCustomer, UnitCardStatus.SuspectedFraud];
    }

    export function parse(areaStr: string): UnitCardStatus {
        return UnitCardStatus[areaStr];
    }

    export function isOn(unitCardStatus: UnitCardStatus, valueToCheck: UnitCardStatus): boolean {
        return valueToCheck === (unitCardStatus & valueToCheck);
    }
}

export default UnitCardStatus;